import { FC } from "react";
import { useNavigate } from "react-router-dom";
import LoyaltyRollbackButton, {
  LoyaltyRollbackButtonProps,
} from "components/atoms/LoyaltyRollbackButton";
import { GET_POPUP_TYPES } from "constants/popupConfig";
import { useRollbackInfo } from "queries/useRollbackInfo";

type LoyaltyRollbackButtonContainerProps = Pick<
  LoyaltyRollbackButtonProps,
  "className"
>;

const LoyaltyRollbackButtonContainer: FC<
  LoyaltyRollbackButtonContainerProps
> = ({ className }) => {
  const navigate = useNavigate();
  const { rollback } = useRollbackInfo();

  const handleClick = () => {
    navigate({
      search: `?popup=${GET_POPUP_TYPES.popup.rollbackInfo}`,
    });
  };

  if (!rollback.rollbackSoon) {
    return null;
  }

  return (
    <LoyaltyRollbackButton
      id="rollback-button"
      onClick={handleClick}
      className={className}
    />
  );
};

export default LoyaltyRollbackButtonContainer;
